import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { HospitalEmployeeRole } from '../enums/hospital-employee-role.enum';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(): boolean {
    const user = this.authService.currentUser();

    // Check if user is authenticated
    if (!this.authService.isAuthenticated() || !user) {
      this.router.navigate(['/login']);
      return false;
    }

    // Check if user has admin or assistant admin role
    if (
      user.role === HospitalEmployeeRole.ADMIN ||
      user.role === HospitalEmployeeRole.ASSISTANT_ADMIN
    ) {
      return true;
    }

    // Redirect to appropriate dashboard based on role
    this.redirectBasedOnRole(user.role);
    return false;
  }

  private redirectBasedOnRole(role: HospitalEmployeeRole): void {
    switch (role) {
      case HospitalEmployeeRole.DOCTOR:
        this.router.navigate(['/dashboard']);
        break;
      case HospitalEmployeeRole.NURSE:
        this.router.navigate(['/nurse/dashboard']);
        break;
      default:
        this.router.navigate(['/dashboard']);
        break;
    }
  }
}
